import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fade from 'react-reveal/Fade';

import { ThemeContext } from '../../contexts/ThemeContext';
import expImgBlack from '../../assets/svg/experience/expImgBlack.svg';
import expImgWhite from '../../assets/svg/experience/expImgWhite.svg';
import './Experience.css';

// makeStyles কে কম্পোনেন্টের বাইরে নিয়ে আসা হলো পারফরম্যান্স বুস্ট করার জন্য
const useStyles = makeStyles((t) => ({
    experienceCard: {
        backgroundColor: ({ theme }) => theme.quaternary,
        transition: 'background-color 0.2s ease-in-out', // হোভার ইফেক্ট স্মুথ করার জন্য
        "&:hover": {
            backgroundColor: ({ theme }) => theme.primary50,
        },
    },
}));

function ExperienceCard({ id, company, jobtitle, startYear, endYear }) {
    const { theme } = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <Fade bottom>
            <div className={`experience-card ${classes.experienceCard}`}>
                <div className="expcard-img" style={{ backgroundColor: theme.primary }}>
                    <img 
                        src={theme.type === 'light' ? expImgBlack : expImgWhite} 
                        alt="Experience icon" 
                    />
                </div>
                <div className="experience-details">
                    <h6 style={{ color: theme.primary }}>{startYear}-{endYear}</h6>
                    <h4 style={{ color: theme.tertiary }}>{jobtitle}</h4>
                    <h5 style={{ color: theme.tertiary }}>{company}</h5>
                </div>
            </div>
        </Fade>   
    );
}

export default ExperienceCard;